"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.new-section.prompt': 'Wprowadź mnie do nowej sekcji zdefiniowanej w <tutorial_structure><sections></tutorial_structure> z atrybutem title o wartości: ',
};
